import tunaiPayLogo from '../../assets/images/machandais-logo-white.png';
import instagram from '../../assets/images/instagram.png';
import tiktok from '../../assets/images/tiktok.svg';
import facebook from '../../assets/images/facebook.png';
import whatsapp from '../../assets/images/whatsapp.png';
import { NavLink } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#1551A7] flex flex-col gap-y-8 items-center py-20 mt-12">
      <div>
        <NavLink to="/">
          <img className="w-28" src={tunaiPayLogo} alt="Tunai Pay Logo" />
        </NavLink>
      </div>
      <div className="flex gap-x-2 items-center">
        <a href="#" target="_blank" rel="noreferrer">
          <img className="w-10" src={instagram} alt="" srcSet="" />
        </a>
        <a href="#">
          <img className="w-8" src={tiktok} alt="" srcSet="" />
        </a>
        <a href="#" target="_blank" rel="noreferrer">
          <img className="w-10" src={facebook} alt="" srcSet="" />
        </a>
        <a href="#" target="_blank" rel="noreferrer">
          <img className="w-10" src={whatsapp} alt="" srcSet="" />
        </a>
      </div>
      <div>
        <ul className="flex flex-col sm:flex-row text-center sm:gap-x-20 gap-y-5 sm:gap-y-0 text-white list-disc font-arOneSans">
          <li className="list-none">
            <a href="mailto:info@tunaipay.id" target="_blank" rel="noreferrer">
              info@machandais.id
            </a>
          </li>
          <li className="pl-0 sm:pl-10 list-none sm:list-disc">
            <a href="#" target="_blank" rel="noreferrer">
              +62 813-1778-0021
            </a>
          </li>
          <li className="pl-0 sm:pl-10 list-none sm:list-disc">
            <NavLink to="#">Terms & Conditions</NavLink>
          </li>
          <li className="pl-0 sm:pl-10 list-none sm:list-disc">
            <NavLink to="#">Privacy Policy</NavLink>
          </li>
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
